import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ZzzConfigService } from 'src/app/zzz/core/config/config.service';
import { CommentaireGeneral, ReponseCommentaireGeneral } from '../models/commentaire-general';

@Injectable({
  providedIn: 'root'
})
export class CommentaireGeneralService {
  private urlApi: string;

  constructor(
    private httpClient: HttpClient,
    private configService: ZzzConfigService
  ) {
    this.urlApi = this.configService.get().authApiEndPoint;
  }

  public creerCommentaire(commentaire: CommentaireGeneral) {
    const url = `${this.urlApi}/sigtapi/commentaire-general`;
    return this.httpClient.post<ReponseCommentaireGeneral>(
      url,
      commentaire
    );
  }

  public supprimerCommentaire(id: number) {
    const url = `${this.urlApi}/sigtapi/commentaire-general/?commentaireGeneralId=${id}`;
    return this.httpClient.delete<ReponseCommentaireGeneral>(
      url
    );
  }
}
